import {
	config
} from '../config'
import {
	Http
} from '../utils/http'
import {
	cache
} from '@/utils/cache';
import router from '@/router';

class Token extends Http {
	constructor() {
		super()
		this.tokenUrl = config.api_base_url + '/token/user';
	}

	// 从服务器获取token
	getTokenFromServer(account,
		password, type = 100) {
		return this.request({
			url: '/token/login',
			data: {
				account,
				password,
				type // 登录type 100email
			},
			method: 'post'
		})
	}

	// 验证token
	verify() {
		const token = cache.session('token') || ''
		if (!token) {
			return this._veirfyRefreshToken()
		} else {
			return this._veirfyFromServer(token);
		}
	}

	// 服务器验证token
	_veirfyFromServer(token) {
		return this.request({
			url: '/token/verify',
			data: {
				token
			},
			method: 'post'
		}).then(res => {
			if (!res.isValid) {
				return this._veirfyRefreshToken()
			} else {
				return this._returnPromise(res)
			}
		}, err => console.log(err))
	}

	_veirfyRefreshToken(loginPage = false) {
		const token = cache.get('refresh_token')
		if (token) {
			return this.request({
				url: '/token/verify/refresh_token',
				data: {
					token
				},
				method: 'post'
			}).then(res => {
				if (!res.isValid) {
					if (!loginPage) {
						router.push({
							path: '/login'
						})
					}
				} else {
					cache.session('token', res.token);
					cache.set('refresh_token', res.refresh_token);
				}
				return this._returnPromise(res)
			}, err => console.log(err))
		} else {
			this.wechatLogin()
		}
	}
	veirfyRefreshToken(loginPage = false) {
		return this._veirfyRefreshToken(loginPage)
	}
	wechatLogin() {
		const appId = 'wx12b6a3e442be5066',
			redirectUri = encodeURIComponent(
				config.login_domain
			),
			url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=lxtx#wechat_redirect`
		location.href = url
	}
}
export {
	Token
}
